import { render, staticRenderFns } from "./AdminAccess.vue?vue&type=template&id=1ca57658&scoped=true&"
import script from "./AdminAccess.vue?vue&type=script&lang=js&"
export * from "./AdminAccess.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccess.vue?vue&type=style&index=0&id=1ca57658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca57658",
  null
  
)

export default component.exports